import { MedicalBagIcon } from './MedicalBagIcon';

/**
 * author: Thomas Hunsaker
 * id 7F6DF58A-C9A3-4CE7-9664-28C04218C628
 * name medical-bag
 * version: 1.8.36
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/medical-bag.svg
 * tags
 * - Medical / Hospital 
 */
export const MedicineIcon = MedicalBagIcon;
export default MedicineIcon